import styled from "styled-components";

export const InBoundCall = styled.div`
    
 .inboundCallInfo {
  background-color: #fff4ed;
  padding: 2px;
  border-radius: 22px;
  border: 1px solid #ffdac1;
  box-shadow: 0px 1px 4px 0px #00000033;
  justify-content: center;
  display: flex;
}

.floatRight {
  float: right;
}

.inboundCallText {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  line-height: 16px;
}

.inboundCallNumberArea {
  padding: 1px 6px 1px 6px;
  background: radial-gradient(
    75.36% 140.35% at 100% 0%,
    #ffe0cb 0%,
    #ffffff 100%
  );
  border-radius: 22px;
}
  
.inboundCallNumberText {
  background-image: linear-gradient(45deg, #ff7f3f 0%, #ff3e5e 100%);
  background-clip: text;
  color: transparent;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-weight: 700;
}

.pushRight {
  margin-left: auto;
}

.inboundCallBox {
  display: none !important;
}

@media only screen and (min-width: 1200px) {
  .inboundCallBox {
    display: block !important;
  }
}`

